
import React from 'react';
import { Button } from '@/components/ui/button';
import { Minus, Plus } from 'lucide-react';

interface ProductQuantitySelectorProps {
  quantity: number;
  increment: () => void;
  decrement: () => void;
}

const ProductQuantitySelector = ({ quantity, increment, decrement }: ProductQuantitySelectorProps) => {
  return (
    <div className="flex items-center space-x-2">
      <Button 
        type="button" 
        size="icon" 
        variant="outline" 
        className="h-8 w-8"
        onClick={decrement}
      >
        <Minus className="h-3 w-3" />
      </Button>
      <span className="w-8 text-center">{quantity}</span>
      <Button 
        type="button" 
        size="icon" 
        variant="outline" 
        className="h-8 w-8"
        onClick={increment}
      >
        <Plus className="h-3 w-3" />
      </Button>
    </div>
  );
};

export default ProductQuantitySelector;
